import styled from '@emotion/styled';

import { Text as _Text } from '@hrworks/sui-core/Text';

const Text = styled(_Text)({
  display: 'flex',
});

const Icon = styled.svg({
  width: 24,
  height: 24,
});

export const S = {
  Text,
  Icon,
} as const;
